export default [
    {
        name: 'spaceship_1',
        price: 5
    },
    {
        name: 'spaceship_2',
        price: 30
    },
    {
        name: 'spaceship_3',
        price: 40
    },
    {
        name: 'spaceship_4',
        price: 30
    },
    {
        name: 'spaceship_5',
        price: 30
    },
    {
        name: 'spaceship_6',
        price: 40
    },
    {
        name: 'spaceship_7',
        price: 30
    }
];
